import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-636ec3b3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "posting-edit-link" }
const _hoisted_2 = { class: "font-medium text-lg" }
const _hoisted_3 = {
  key: 0,
  class: "text-sm"
}
const _hoisted_4 = { class: "text-sm no-underline2" }

import type { Challenge, JobPosting } from "@/api/models/types";
import { ChallengeState, JobPostingState } from "@/api/models/types";
import ArrowFrontIcon from "@/assets/icons/arrow-front.svg";
import IconLoadingFull from "@/assets/icons/loading-full.svg";
import IconLoading from "@/assets/icons/loading.svg";
import { Routes } from "@/router";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PostingEditLink',
  props: {
    posting: {}
  },
  setup(__props: any) {

const props = __props;



const jobPosting = computed(() =>
  props.posting.__typename === "JobPosting" ? props.posting : null
);
const challenge = computed(() => (props.posting.__typename === "Challenge" ? props.posting : null));

const isPublic = computed(() => {
  return (
    props.posting.state === JobPostingState.Public || props.posting.state === ChallengeState.Public
  );
});

const routeName = computed(() => {
  if (jobPosting.value) {
    return Routes.JOB_POSTING_CREATE;
  } else if (isPublic.value) {
    return Routes.CHALLENGE_DETAIL;
  } else {
    return Routes.CHALLENGE_CREATE;
  }
});

const params = computed(() => {
  return jobPosting.value || !isPublic.value
    ? { slug: props.posting.slug, step: "schritt1" }
    : { slug: props.posting.slug };
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: {
        name: routeName.value,
        params: params.value,
      },
      class: "hover:text-primary-1 transition-colors underline"
    }, {
      default: _withCtx(() => [
        _createElementVNode("h3", _hoisted_2, [
          _createTextVNode(_toDisplayString(_ctx.posting.displayTitle) + " ", 1),
          _createVNode(_unref(ArrowFrontIcon), { class: "xl:w-5 w-8 mr-2 xl:mr-1 mb-1 shrink-0 inline-block" })
        ])
      ]),
      _: 1
    }, 8, ["to"]),
    (challenge.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(challenge.value.challengeType.name), 1))
      : _createCommentVNode("", true),
    _createElementVNode("p", _hoisted_4, [
      (isPublic.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_unref(IconLoadingFull), { class: "status-icon is-public" }),
            _createTextVNode(" veröffentlicht ")
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(_unref(IconLoading), { class: "status-icon" }),
            _createTextVNode(" Entwurf ")
          ], 64))
    ])
  ]))
}
}

})